import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import CopyMail from "src/containers/CopyMail/CopyMail";
import EditOutgoingMail from "src/containers/EditOutgoingMail/EditOutgoingMail";
import { useAppSelector } from "src/custom-hooks/redux/redux";
import { Props } from "./interfaces";
import { ActionsContainer } from "./styles";
import UploadProcessedDocument from "./UploadProcessedDocument";
import UploadSendingDocument from "./UploadSendingDocument";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";
import ClassifyMail from "../../../ClassifyMail/ClassifyMail";
import DeleteMail from "../../../DeleteMail/DeleteMail";
import DiscardMail from "../../../DiscardMail/DiscardMail";

const OutgoingMailActions = ({
  outgoingMail,
  handleNotifyParent,
  canUpload,
  canClassify,
  canProcess,
  canRead,
}: Props) => {
  const [closePopover, setClosePopover] = useState<boolean>(false);
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const isAdmin = currentUserAuthorizations?.canChangeAll;

  return (
    <>
      <SimplePopover
        buttonType="icon"
        buttonContent={<FontAwesomeIcon icon={faEllipsisV} />}
        shouldClose={closePopover}
        onOpen={() => setClosePopover(false)}
      >
        <ActionsContainer>
          <EditOutgoingMail
            item={outgoingMail}
            handleNotifyParent={() => {
              handleNotifyParent();
              setClosePopover(true);
            }}
            readOnly={!canUpload}
          />

          {canProcess && (
            <UploadProcessedDocument
              outgoingMail={outgoingMail}
              handleNotifyParent={() => {
                handleNotifyParent();
                setClosePopover(true);
              }}
            />
          )}
          {canClassify && (
            <ClassifyMail
              outgoingMail={outgoingMail}
              handleNotifyParent={() => {
                handleNotifyParent();
                setClosePopover(true);
              }}
            />
          )}
          {canProcess && (
            <UploadSendingDocument
              outgoingMail={outgoingMail}
              handleNotifyParent={() => {
                handleNotifyParent();
                setClosePopover(true);
              }}
            />
          )}
          {canUpload && (
            <>
              <DiscardMail
                outgoingMail={outgoingMail}
                handleNotifyParent={() => {
                  handleNotifyParent();
                  setClosePopover(true);
                }}
              />
              <CopyMail
                outgoingMail={outgoingMail}
                handleNotifyParent={() => {
                  handleNotifyParent();
                  setClosePopover(true);
                }}
              />
            </>
          )}

          {isAdmin && (
            <DeleteMail
              outgoingMail={outgoingMail}
              handleNotifyParent={handleNotifyParent}
            />
          )}
        </ActionsContainer>
      </SimplePopover>
    </>
  );
};

export default OutgoingMailActions;
